import apiUrls from '@services/api/api-urls';
import httpService from '@services/httpService';
import navigationService from '@services/navigation-service';

export default {
	sendTopUp(params): void {
		httpService.post(apiUrls.sendTopUp.url, params)
			.then(({ data }) => {
				navigationService.goTo(data?.postUrl);
			});
	},
};
